import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";

const aboutLinks = [
  { to: "/about", label: "关于看料" },
  { to: "/about#values", label: "内容原则" },
  { to: "/about#team", label: "编辑团队" },
  { to: "/faq", label: "常见问题" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200/80">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg text-lg font-bold bg-primary-500 text-background-50">
                看
              </span>
              <div className="leading-none">
                <p className="font-heading text-xl font-bold text-foreground-950">看料</p>
                <p className="mt-1 text-[11px] tracking-widest text-foreground-500">
                  每日甄选好料 · 不错过值得看的
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-7 text-foreground-700">
              看料是编辑团队每日甄选的内容推荐平台。我们以「值得看、有启发、不浪费读者时间」为原则，
              从数字工作、阅读新知、生活灵感到认知成长，帮你把最好的精力留给最有价值的内容。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="mailto:hello@kanliao.example"
                className="inline-flex h-10 items-center gap-2 rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                <i className="ri-mail-line" />
                联系编辑团队
              </a>
              <span className="text-xs text-foreground-500">hello@kanliao.example</span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-base font-bold text-foreground-950">内容栏目</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="inline-flex items-center gap-2 text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    <i className={`${c.icon} text-primary-500`} />
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="font-heading text-base font-bold text-foreground-950">关于</h3>
            <ul className="mt-4 space-y-2.5">
              {aboutLinks.map((l) => (
                <li key={l.to + l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-base font-bold text-foreground-950">今日必读</h3>
            <ul className="mt-4 space-y-3">
              {[
                { slug: "pomodoro-advanced-guide", label: "番茄钟进阶玩法" },
                { slug: "retrospect-decides-ceiling", label: "复盘决定你的上限" },
                { slug: "read-100-books", label: "一年读一百本书的方法" },
              ].map((a) => (
                <li key={a.slug}>
                  <Link
                    to={`/article/${a.slug}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700 line-clamp-1"
                  >
                    {a.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 看料 · 每日甄选值得看的好料，覆盖数字工作、阅读新知与生活灵感。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              rel="nofollow"
              className="text-xs text-foreground-500 transition-colors hover:text-primary-700"
            >
              内容原则
            </a>
            <a
              href="mailto:hello@kanliao.example"
              className="text-xs text-foreground-500 transition-colors hover:text-primary-700"
            >
              联系我们
            </a>
            <a
              href="#top"
              aria-label="返回顶部"
              className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-background-300/70 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}